// Agent Dashboard Configuration
// This file contains the numeric access code for agent login

export const agentConfig = {
  accessCode: '123456', // Change this to your desired numeric code
};

